import { Route, Routes } from "react-router-dom";

import AdminRoutes from "./AdminRoutes";
import SellerRoutes from "./SellerRoutes";
import PublicRoutes from "./PublicRoutes";
import NotFound from "./views/NotFound";

const AppRoutes = (props: any) => {
  const { isAuthenticated, isVerifying } = props;

  return (
    <Routes>
      {PublicRoutes()}
      {AdminRoutes()}
      {SellerRoutes()}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
